export default __webpack_public_path__ + "static/media/ptt.9ac3a88e.png";